const czyKwotyWTysiacach = header =>
  header.KodSprawozdania === 'SprFinJednostkaInnaWTysiacach' ||
  header.KodSprawozdania === 'SprFinJednostkaMalaWTysiacach' ||
  header.KodSprawozdania === 'SprFinJednostkaMikroWTysiacach' ||
  header.KodSprawozdania === 'SprFinOpWTysiacach' ||
  header.KodSprawozdania === 'SprFinSkonsolidowanaJednostkaInnaWTysiacach' ||
  header.KodSprawozdania === 'SprFinDomMaklerskiWTysiacach'

const dajStrukture = header => {
  switch (header.KodSprawozdania) {
    case 'SprFinJednostkaInnaWTysiacach':
    case 'SprFinJednostkaInnaWZlotych':
      return 'Inna'
    case 'SprFinJednostkaMalaWTysiacach':
    case 'SprFinJednostkaMalaWZlotych':
      return 'Mala'
    case 'SprFinJednostkaMikroWTysiacach':
    case 'SprFinJednostkaMikroWZlotych':
      return 'Mikro'
    case 'SprFinOpWTysiacach':
    case 'SprFinOpWZlotych':
      return 'OP'
    case 'SprFinDomMaklerskiWTysiacach':
    case 'SprFinDomMaklerskiWZlotych':
      return 'DomMaklerski'
    case 'SprFinSkonsolidowanaJednostkaInnaWZlotych':
    case 'SprFinSkonsolidowanaJednostkaInnaWTysiacach':
      return 'SkonsolidowanaInna'
    default:
      return null
  }
}

export { czyKwotyWTysiacach, dajStrukture }
